import React from 'react'

import PerfectScrollbar from 'react-perfect-scrollbar'
import { Skeleton } from '@material-ui/lab'
import {
  Box,
  colors,
  Grid,
  lighten,
  Paper,
  Typography,
  useMediaQuery,
} from '@material-ui/core'

import { RadialGradientChart } from 'components'
import { EvidenceCard, RadialGraphicsCard } from './components'

import useAuthSupplier from 'hooks/useAuthSupplier'
import useFetch from 'hooks/useFetch'

import * as service from 'service'
import theme from 'theme'
import useStyles from './styles'

const InformationCard = () => {
  const { companySupplier, loaded } = useAuthSupplier()
  const classes = useStyles()

  const isXsDown = useMediaQuery(theme.breakpoints.down('xs'), {
    defaultMatches: true,
  })

  const { response, isLoading } = useFetch(
    service.supplierPortal.companySuppliers.stats,
    { id: companySupplier?.id },
    [companySupplier?.id],
    loaded && !!companySupplier?.id,
  )

  const companySupplierStats = response?.data

  return (
    <Paper className={classes.container}>
      <Grid container spacing={2} className={classes.gridContainer}>
        <Grid item xs={12} lg={4} className={classes.gridItem}>
          <Typography variant="h5">Progresso</Typography>
          <Paper className={classes.chartContainer}>
            {isLoading ? (
              <Skeleton
                variant="rect"
                animation="wave"
                width="100%"
                height={isXsDown ? 300 : 370}
              />
            ) : (
              <RadialGradientChart
                trackBackground={colors.grey['A100']}
                value={
                  companySupplierStats?.companySupplier?.generalProgress || 0
                }
                width={300}
                height={isXsDown ? 300 : 370}
                containerProps={{ display: 'flex', justifyContent: 'center' }}
                primaryColor={colors.teal[900]}
                secondaryColor={lighten(colors.green[900], 0.5)}
              />
            )}
          </Paper>
        </Grid>
        <Grid item xs={12} lg={4} className={classes.gridItem}>
          <Typography variant="h5">Resolução dos questionários</Typography>
          <Box height="100%">
            <PerfectScrollbar
              options={{ useBothWheelAxes: true }}
              className={classes.scrollbar}
            >
              <Box
                display="flex"
                flexDirection="column"
                gridGap={theme.spacing(2)}
                maxHeight={300}
              >
                {isLoading
                  ? [...Array(4)].map((_, index) => (
                      <Box key={index}>
                        <Skeleton variant="rect" animation="wave" height={84} />
                      </Box>
                    ))
                  : companySupplierStats?.questionnaires?.map(
                      (questionnaire) => (
                        <RadialGraphicsCard
                          key={questionnaire?.id}
                          title={questionnaire?.kind}
                          subtitle={`Sua organização respondeu ${questionnaire?.totalAnswers}/${questionnaire?.totalQuestions} questões.`}
                          value={questionnaire?.totalAnswers ?? 0}
                          percentage={questionnaire?.answersPercentage}
                          onlyNumber
                        />
                      ),
                    )}
              </Box>
            </PerfectScrollbar>
          </Box>
        </Grid>
        <Grid item xs={12} lg={4} className={classes.gridItem}>
          <Typography variant="h5">Evidências</Typography>
          <Box height="100%">
            <PerfectScrollbar
              options={{ wheelPropagation: false, useBothWheelAxes: true }}
              className={classes.scrollbar}
            >
              <Box
                display="flex"
                flexDirection="column"
                gridGap={theme.spacing(2)}
                maxHeight={300}
              >
                {isLoading
                  ? [...Array(4)].map((_, index) => (
                      <Box key={index}>
                        <Skeleton variant="rect" animation="wave" height={84} />
                      </Box>
                    ))
                  : companySupplierStats?.questionnaires?.map(
                      (questionnaire) => {
                        if (questionnaire?.totalRequiredEvidences === 0)
                          return null

                        return (
                          <EvidenceCard
                            key={questionnaire?.id}
                            title={questionnaire?.kind}
                            value={`${questionnaire?.totalEvidences}/${questionnaire?.totalRequiredEvidences}`}
                            progressValue={questionnaire?.evidencesPercentage}
                            minHeight={83}
                          />
                        )
                      },
                    )}
              </Box>
            </PerfectScrollbar>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default InformationCard
